import { ButtonTriggerEvent } from '../../../common/components';

export class EventDetailsModalActions {
    confirm: (event: ButtonTriggerEvent, progressCallback?: (progress) => void) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details.modal/event.details.modal.provider.ts